// @flow
import type {Element} from 'react'
import React from 'react'
import classNames from 'classnames'

import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import Item from 'components/proposals/Part/Item'
import ListItem from '../../ListItem'

type Props = $ReadOnly<{
  changeKey: string,
  list: Item[],
  movingIn: boolean,
  movingOut: boolean,
  title: string,
}>

function List({changeKey, list, movingIn, movingOut, title}: Props): null | Element<"div"> {
  const changed = list.filter((item) => !item.isUnchanged)

  if (changed.length === 0)
    return null

  const listItemType = () => {
    if (movingIn)
      return 'movingIn'

    if (movingOut)
      return 'movingOut'

    return null
  }

  const className = classNames('proposal-summary-list', `test-field-${changeKey}`)

  return (
    <div className={className} key={changeKey}>
      <ChangeTitle title={title} />
      <div className="proposal-summary-list__items">
        {changed.map((item) => (
          <div className="proposal-summary-list__item" key={item.databaseId}>
            <ListItem type={listItemType()}>
              <a href={item.resourcePath}>{item.displayName}</a>
            </ListItem>
          </div>
        ))}
      </div>
    </div>
  )
}

List.defaultProps = {
  movingIn: false,
  movingOut: false,
}

export default List
